import React, { Component } from 'react';

export default class View extends Component {
	render() {
		return (
			<div  style={{textAlign:'left', overflowWrap: 'break-word' }}>
				<h3 style={{textAlign:'center'}}>Failed to Cancel PA</h3>
				<hr/>
				<p>You cannot cancel this Prior Authorization. The Prior Authorization may have already been cancelled or completed by a pharmacy or DME provider. </p>
			</div>
		);
	}
}